import React, {Component} from 'react'
import {Button, Modal, Spin, Table} from 'antd'
import {DownloadOutlined} from '@ant-design/icons'
import * as PropTypes from 'prop-types'
import {inject, observer} from 'mobx-react'
import {withTranslation} from 'react-i18next'

function MinusCircleOutlined() {
  return null
}

MinusCircleOutlined.propTypes = {onClick: PropTypes.func}

@inject('rulesManagementStore', 'uiState')
@observer
class LogModal extends Component {

  downloadError = (errorFilePath) => {
    const {uiState} = this.props
    uiState.onChangeFetchingExport('/api/v1/rule/download/errorFile', {errorFilePath}, errorFilePath)
  }

  render() {
    const {logModalVisible, handleCancel, rulesManagementStore, ruleName, t} = this.props
    const {isFetching, ruleLogList} = rulesManagementStore

    return (
      <Spin spinning={isFetching}>
        <Modal title={`${ruleName} ${t(`rulesManagement.log`)}`} width={1200} visible={logModalVisible}
               maskClosable={false} destroyOnClose={true} centered onCancel={() => handleCancel('logModalVisible')}
               footer={null}
        >
          <Table dataSource={ruleLogList} rowKey="id" pagination={false}>
            <Table.Column title={t(`rulesManagement.status`)} dataIndex="ruleStatusName" key="ruleStatusName" ellipsis={true}/>
            <Table.Column title={t(`rulesManagement.message`)} dataIndex="errorMessage" key="errorMessage" ellipsis={true}/>
            <Table.Column title={t(`rulesManagement.startTime`)} dataIndex="beginTime" key="beginTime" ellipsis={true}/>
            <Table.Column title={t(`rulesManagement.endTime`)} dataIndex="endTime" key="endTime" ellipsis={true}/>
            <Table.Column align="center" title={t(`general.action`)} key="Action" render={(text, record) => {
              return (
                <>
                  {
                    record?.errorFilePath ?
                      <Button type="link" onClick={() => this.downloadError(record?.errorFilePath)} icon={<DownloadOutlined/>}
                              title={t(`general.download`)}/> : null
                  }
                </>
              )
            }}/>
          </Table>
        </Modal>
      </Spin>
    )
  }
}

export default withTranslation()(LogModal)
